// Bildirim slug'ları → panel gösterimi (kategori + tıklanınca gidilecek yer).
// BE her bildirimi `data.type` içindeki slug ile üretir; FE bu haritayı kullanır.
// Yeni bir bildirim eklerken TEK yapılacak şey: buraya bir satır eklemek.
//
// route(userType, data) → { path, search?, state? } ya da null (yönlendirme yok).

// Sözleşme bildirimlerinin yönlendirmesi Header'daki özel sözleşme dalında yapılır
// (müşteri → /my-contracts/:operationID, admin/merchant → /customer-contracts/:customerID).
// Burada yalnız KATEGORİ tanımlıdır; route yok.
const contractType = { category: "contract", route: null };

const paymentsRoute = (userType, data) => (
  userType === "customer"
    ? { path: "/my-payments", state: { debtID: data?.debtID || undefined } }
    : { path: data?.customerID ? `/payments/${data.customerID}` : "/payments" }
);

// kategori: FE'de ikon/renk gruplaması için (sözleşme, ödeme, fatura bilgisi…)
export const NOTIFICATION_TYPES = {
  // ---- Sözleşmeler ----
  contract_created: contractType,
  contract_awaiting_entry: contractType,
  contract_unlocked: contractType,
  contract_resent: contractType,
  contract_signature_cleared: contractType,
  contract_merchant_signed: contractType,
  contract_merchant_to_sign: contractType,
  contract_completed: contractType,
  contract_cancelled: contractType,
  contract_rejected: contractType,
  contract_reminder_unsigned: contractType,
  customer_signed_contract: contractType,
  contract_uploaded: contractType,
  contract_approved: contractType,
  contract_upload_rejected: contractType,

  // Sözleşme oluştu ama firmanın sözleşmede yer alan bilgileri eksik (ekibe uyarı).
  // Kategori "company": Header'ın sözleşme dalına düşmesin, firma profiline gitsin.
  contract_company_info_missing: {
    category: "company",
    route: (userType, data) => (
      data?.companyID
        ? { path: "/firm-list", state: { openCompanyID: data.companyID, openCompanyTab: "profile" } }
        : { path: "/firm-list" }
    ),
  },

  // Aynı uyarının FİRMA tarafındaki karşılığı: kendi firma profiline götürür.
  company_contract_info_missing: {
    category: "company",
    route: (userType, data) => (
      userType === "merchant"
        ? { path: "/my-warehouse-firm", state: { initialTab: "profile" } }
        : { path: "/firm-list", state: { openCompanyID: data?.companyID, openCompanyTab: "profile" } }
    ),
  },

  // ---- Yetkili kişi işlemleri ----
  // Oda sahibine, YETKİLİ KİŞİSİNİN yaptığı işlem için düşen bildirim (BE:
  // snapshotauthorizedusers::notifyOwnerActivity). Yalnız yetki kaydında
  // "Tüm güncellemelerde ve taleplerde bilgilendirme istiyorum" açıksa gelir.
  // data.action işlemi söyler; yönlendirme de ona göre değişir.
  authorized_user_activity: {
    category: "warehouse",
    route: (userType, data) => {
      switch (data?.action) {
        case "payment":
        case "billing":
          return { path: "/my-payments" };
        case "contract":
          return { path: "/my-contracts" };
        default:
          return { path: "/my-warehouses" };
      }
    },
  },

  // ---- Teklifler ----
  // Müşteri kendisine gönderilen teklifi REDDEDİNCE (BE: offers::cancel, çağıran=müşteri)
  // Troy Depo adminlerine + teklifin sahibi partnerde "Teklifi Gör" yetkisi olan personele
  // düşer. Tıklayınca ilgili teklifin bulunduğu teklifler ekranını açar (admin → /admin-offers,
  // merchant → /transport-requests/:requestID). BE data'sı:
  // { type:"offer_rejected", requestID, offerID, customerID }
  offer_rejected: {
    category: "offer",
    route: (userType, data) => {
      const requestID = String(data?.requestID ?? "").trim();
      if (userType === "merchant") {
        return requestID ? { path: `/transport-requests/${requestID}` } : { path: "/transport-requests" };
      }
      return requestID
        ? { path: `/admin-offers?requestID=${encodeURIComponent(requestID)}` }
        : { path: "/admin-offers" };
    },
  },

  // ---- Ödemeler ----
  payment_received: { category: "payment", route: paymentsRoute },
  // Tahsilat alındı ama borç kapanmadı: yöneticiye düşen mutabakat uyarısı.
  payment_settle_mismatch: {
    category: "payment",
    title: "Tahsilat mutabakatı",
    route: paymentsRoute,
  },
  payment_invoice: { category: "payment", route: paymentsRoute },
  // Troy Depo, FİRMAYA partner faturası yüklediğinde giden bildirim (payments::uploadInvoice).
  // Haritada olmadığı için tıklanınca hiçbir yere gitmiyordu.
  payment_partner_invoice: { category: "payment", route: paymentsRoute },
  invoice_uploaded: { category: "payment", route: paymentsRoute },
  payment_due_soon: { category: "payment", route: paymentsRoute },
  payment_overdue: { category: "payment", route: paymentsRoute },
  payment_method_required: {
    category: "billing",
    route: () => ({ path: "/my-payments", state: { openCards: true } }),
  },
  default_card_changed: {
    category: "payment",
    route: () => ({ path: "/my-payments", state: { openCards: true } }),
  },
  card_expiring_soon: {
    category: "payment",
    route: () => ({ path: "/my-payments", state: { openCards: true } }),
  },

  // ---- Fatura bilgileri / belgeler ----
  billing_info_required: {
    category: "billing",
    route: () => ({ path: "/profile", state: { profileTab: "billing" } }),
  },
  billing_info_reminder: {
    category: "billing",
    route: (userType, data) => (
      Number(data?.paymentMissing) === 1 && Number(data?.billingMissing) !== 1
        ? { path: "/my-payments", state: { openCards: true } }
        : { path: "/profile", state: { profileTab: "billing" } }
    ),
  },
  billing_documents_required: {
    category: "billing",
    route: () => ({ path: "/profile", state: { profileTab: "documents" } }),
  },
  // Adminlere giden bilgilendirmeler: ilgili müşteriye götürür.
  billing_info_updated: {
    category: "billing",
    route: (userType, data) => (data?.customerID ? { path: `/my-customers`, state: { openCustomerID: data.customerID, openCustomerTab: "billing" } } : null),
  },
  billing_type_changed: {
    category: "billing",
    route: (userType, data) => (data?.customerID ? { path: `/my-customers`, state: { openCustomerID: data.customerID, openCustomerTab: "billing" } } : null),
  },
  billing_document_uploaded: {
    category: "billing",
    route: (userType, data) => (data?.customerID ? { path: `/my-customers`, state: { openCustomerID: data.customerID, openCustomerTab: "documents" } } : null),
  },

  // Web sitesi / Troyi asistanı lead formundan iletişim bilgisi bırakan kişi — adminlere düşer.
  // Tıklanınca O KULLANICININ detayını açar (Müşteriler > profil sekmesi).
  // BE data'sı: { requestID, userID, channel, type }  (web-apis::createLeadFormRequest)
  // ⚠️ userID BOŞ gelebilir: e-postası müşteri olmayan bir hesaba (admin/partner) aitse
  // kullanıcı oluşturulmaz ve BE "kullanıcı olarak eklendi" demez. O durumda yönlendirme
  // yapılmaz, bildirim yalnız metin olarak kalır.
  new_lead_form_request: {
    category: "customer",
    // KULLANICILAR sayfasi (Musteriler DEGIL): lead formundan gelen kisi "İletişime
    // Geçilecek" (5) statusunde acilir, ekip onu Kullanicilar listesinde takip ediyor.
    route: (userType, data) => (
      data?.userID
        ? { path: "/users", state: { openCustomerID: data.userID } }
        : null
    ),
  },

  // partner.troydepo.com'dan yeni partner başvurusu — adminlere düşer, Başvurular sayfasına gider.
  merchant_application_received: {
    category: "company",
    title: "Yeni Partner Başvurusu",
    route: () => ({ path: "/admin-applications" }),
  },

  // ---- Mağaza (2. el) — 28.10.2026: her mağaza mailinin panel bildirimi (BE store.php / store-ext.php) ----
  // Hesap bölümleri Profil › Mağaza sekmesinde (StoreAccountPanel.storeAccountPath ile aynı adres;
  // Header'a mağaza modülünü yüklememek için burada yeniden kurulur).
  store_listing_submitted: { category: "store", route: () => ({ path: storeAccountRoute("ilanlar") }) },
  store_listing_approved: {
    category: "store",
    route: (userType, data) => (data?.slug ? { path: `/store/urun/${encodeURIComponent(data.slug)}` } : { path: storeAccountRoute("ilanlar") }),
  },
  // Reddedilen ilan düzenlenip yeniden gönderilir (mail linki de ilan-ver/<slug>).
  store_listing_rejected: {
    category: "store",
    route: (userType, data) => (data?.slug ? { path: `/store/ilan-ver/${encodeURIComponent(data.slug)}` } : { path: storeAccountRoute("ilanlar") }),
  },
  // Ekibe: onay bekleyen üye ilanı.
  store_listing_review: { category: "store", route: () => ({ path: "/listing-approvals" }) },
  store_new_message: {
    category: "store",
    route: (userType, data) => ({ path: storeAccountRoute("mesajlar", data?.conversationID || "") }),
  },
  store_price_drop: {
    category: "store",
    route: (userType, data) => (data?.slug ? { path: `/store/urun/${encodeURIComponent(data.slug)}` } : { path: storeAccountRoute("alarmlar") }),
  },
  store_order_paid: { category: "store", route: () => ({ path: storeAccountRoute("siparisler") }) },
};

function storeAccountRoute(bolum, no = "") {
  const q = new URLSearchParams({ tab: "store", bolum });
  if (/^[A-Za-z0-9_-]{1,200}$/.test(String(no || ""))) q.set("no", String(no));
  return `/profile?${q.toString()}`;
}

export const getNotificationTypeConfig = (type) => NOTIFICATION_TYPES[String(type || "")] || null;

export const isContractCategory = (type) => getNotificationTypeConfig(type)?.category === "contract";
